/**
 * DirectorsTrigger — Small button that opens the Directors modal for the
 * hosting node. Drop into any node next to its prompt textarea:
 *
 *   <DirectorsTrigger
 *     nodeType="nanoBanana"
 *     currentPrompt={prompt}
 *     onInsert={setPrompt}
 *   />
 */
import { Film } from 'lucide-react';
import { useDirectorsStore } from '../../store/directorsStore';

const DirectorsTrigger = ({ nodeId, nodeType, currentPrompt, onInsert, className = '' }) => {
  const openDirectors = useDirectorsStore((s) => s.open);

  // Oculto a pedido del producto (limpieza previa al rediseño de entrada):
  // el componente y DirectorsComposer quedan intactos, sólo no se expone el
  // botón en los nodos. Para reactivarlo, borrar este `return null`.
  return null;

  return (
    <button
      type="button"
      className={`directors-trigger ${className}`}
      onClick={() => openDirectors({ nodeId, nodeType, currentPrompt, onInsert })}
      title="Abrir Directors: pipeline cinematográfico para un prompt hiperpreciso"
      data-testid={`directors-trigger-${nodeType || 'node'}`}
    >
      <Film size={11} />
      <span>Directors</span>
    </button>
  );
};

export default DirectorsTrigger;
